import React, { useMemo } from "react";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";

interface Props {
  image: string;
}

export default function (props: Props) {
  const isCustom = useMemo(() => {
    return props.image?.includes(".");
  }, [props.image]);

  const CONTENT = useMemo(() => {
    if (isCustom) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            width: "100%",
            height: "100%"
          }}
        >
          <img
            data-twic-src={`image:/cdm/jetpack/gifts/${props.image}`}
            data-src-transform={"cover=WxH/quality=100"}
            style={{
              width: "100%",
              height: "100%"
            }}
          />
        </div>
      );
    }
    return <TwemojiWrapper>{props.image}</TwemojiWrapper>;
  }, [props.image, isCustom]);

  return CONTENT;
}
